export default __webpack_public_path__ + "static/media/image-email-desktop.90af6b09.png";